"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransitionTimeMs;

function getTransitionTimeMs(heightTransition) {
  var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
  if (!m) throw new Error('Could not parse time from transition value');
  return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}
//# sourceMappingURL=getTransitionTimeMs.js.map